import { Time } from '@instinet-analytics/core-lib';
import './TimeLabel.scss';
import { TimeRangeModal } from './TimeRangeModal';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import React from 'react';
import {
    TimeRangeStreamData,
    useTimeRange,
} from 'utils/components/TimeLabel/useTimeRange.ts';

const showTime = (t: Time) =>
    `${t.hours}:${t.mins.toString().padStart(2, '0')}`;

export function TimeLabel({
    component,
    data,
    onChanged,
}: {
    component: { startTime?: Time | undefined; endTime?: Time | undefined };
    data: TimeRangeStreamData;
    onChanged: (startTime: Time | undefined, endTime: Time | undefined) => void;
}) {
    const timeLabelData = useTimeRange(data, component);

    const { fromTime, endTime, userOverridden } = timeLabelData;

    let label = <span>Set Time Range</span>;

    if (fromTime && endTime) {
        label = (
            <span>
                From {showTime(fromTime)} to {showTime(endTime)}
            </span>
        );
    } else if (fromTime) {
        label = <span>From {showTime(fromTime)} </span>;
    } else if (endTime) {
        label = <span>To {showTime(endTime)}</span>;
    }

    const onClickResetDates = () => {
        onChanged(undefined, undefined);
    };

    return (
        <div className="TimeLabel">
            {label}
            <TimeRangeModal data={timeLabelData} onChanged={onChanged} />
            {userOverridden && (
                <ToolbarIcon
                    name={'trash'}
                    className="reset-dates-button"
                    onClick={onClickResetDates}
                    tooltip={'Reset dates'}
                />
            )}
        </div>
    );
}
